/* ShellCuties pizzazz: scroll reveal + parallax. */
(function () {
  'use strict';

  // Respect reduced motion
  const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  // --- Scroll-triggered reveal ---
  const revealTargets = [
    // Custom sections
    '.story', '.spot', '.lb', '.founder', '.asym',
    // Stock sections worth revealing
    '.featured-collection', '.collection-list', '.multicolumn', '.newsletter',
  ];

  const allReveal = new Set();
  revealTargets.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => allReveal.add(el));
  });

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('sc-reveal', 'is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    allReveal.forEach((el) => {
      el.classList.add('sc-reveal');
      io.observe(el);
    });

    // Stagger product grid children
    document.querySelectorAll(
      '.product-grid, .collection-list__list, .featured-collection .collection-list, .asym__stack, .multicolumn-list'
    ).forEach((el) => {
      el.setAttribute('data-sc-reveal-stagger', '');
      io.observe(el);
    });
  } else {
    // No IO support — just show everything
    allReveal.forEach((el) => el.classList.add('is-visible'));
  }

  // --- Parallax on hero + lookbook backgrounds ---
  const parallaxEls = document.querySelectorAll('.ed-hero__media, .lb__media');
  if (!parallaxEls.length) return;

  const SPEED = 0.25; // 25% of scroll speed
  let ticking = false;

  function updateParallax() {
    const vh = window.innerHeight;
    parallaxEls.forEach((media) => {
      const section = media.closest('.ed-hero, .lb');
      if (!section) return;
      const rect = section.getBoundingClientRect();

      // Only animate when section is anywhere near viewport
      if (rect.bottom < -200 || rect.top > vh + 200) return;

      // 0 when section center is at viewport center
      const sectionCenter = rect.top + rect.height / 2;
      const viewportCenter = vh / 2;
      const distance = sectionCenter - viewportCenter;
      const offset = distance * SPEED * -1;

      media.style.setProperty('--sc-parallax-y', offset.toFixed(1) + 'px');
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  updateParallax();
})();
